var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " " + _vm._s(_vm.titulo) + " ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": 'Perfil da Turma em ' + _vm.funcionalidade + '*',
      "dense": "",
      "outlined": "",
      "counter": "25",
      "maxlength": "25",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  }), _c('v-select', {
    attrs: {
      "label": "Nível de Ensino*",
      "outlined": "",
      "dense": "",
      "items": _vm.niveisDeEnsino,
      "item-value": "id",
      "item-text": "descricao",
      "return-object": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nivelDeEnsino,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nivelDeEnsino", $$v);
      },
      expression: "content.nivelDeEnsino"
    }
  }), _c('v-select', {
    attrs: {
      "label": "Componente Curricular*",
      "outlined": "",
      "dense": "",
      "items": _vm.componentesCurriculares,
      "item-value": "id",
      "item-text": "descricao",
      "return-object": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.componenteCurricular,
      callback: function ($$v) {
        _vm.$set(_vm.content, "componenteCurricular", $$v);
      },
      expression: "content.componenteCurricular"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "O que é esperado do aluno*",
      "outlined": "",
      "rows": "4",
      "dense": "",
      "counter": "2500",
      "maxlength": "2500",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios.")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }